import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_2 = { style: {"margin-right":"4px"} }
const _hoisted_3 = { style: {"max-width":"800px","font-size":"14px"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"width":"100%"} }
const _hoisted_6 = { class: "flex-center" }

import { QuestionFilled } from '@element-plus/icons-vue'
import { ref, reactive, computed, watch } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { t } from '@/plugins/i18n'
import { updateSpecification } from '@/apis/stock'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
    row: { type: null, required: false },
    isTitle: { type: null, required: false }
  },
  setup(__props: any) {

const props = __props as { row?: any; isTitle?: any }


const editing = ref(false)

const toggle = () => {
  editing.value = !editing.value
}

const input = ref()

const show = () => {
  toggle()
  input.value.focus()
}

const update = () => {
  const value = specification.value.trim()
  toggle()
  if (value !== props.row?.washedlabelSpecification) {
    updateSpecification({
      productSku: props.row?.productSku,
      shopProductSku: props.row?.shopProductSku,
      specification: value ?? ''
    }).then((res) => {
      if (res.success) {
        ElMessage.success(t('保存成功'))
        const row = props.row
        row.washedlabelSpecification = value
      }
    })
  } else {
    specification.value = props.row.washedlabelSpecification ?? ''
  }
}

const specification = ref(props.row?.washedlabelSpecification ?? '')

watch(() => props.row?.washedlabelSpecification, (v) => {
  specification.value = v
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!

  return (__props.isTitle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('客户商品规格')), 1),
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "top",
          "popper-class": "tool-tip-no-border"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('客户商品规格只用于在水洗标上打印')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { color: "#999" }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuestionFilled))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tooltip, {
            placement: "top",
            effect: "light",
            disabled: !specification.value
          }, {
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(specification.value), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("span", {
                  onClick: show,
                  style: {"color":"var(--acolor)","cursor":"pointer"},
                  class: "line--only"
                }, [
                  _createTextVNode(_toDisplayString(specification.value) + " ", 1),
                  _createVNode(SvgIcon, {
                    name: "pencil",
                    style: {"color":"var(--acolor)"}
                  })
                ], 512), [
                  [_vShow, !editing.value]
                ])
              ])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _withDirectives(_createElementVNode("span", null, [
            _createVNode(_component_el_input, {
              size: "small",
              ref: (_value, _refs) => {
                _refs['input'] = _value
                input.value = _value
              },
              modelValue: specification.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((specification).value = $event)),
              onBlur: update,
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ], 512), [
            [_vShow, editing.value]
          ])
        ])
      ]))
}
}

})